import React, { useState, useEffect } from 'react'
import { IconArrowDown, IconArrowUpBig, IconEdit, graphLegendArrow } from '../../../../assets/images/icons'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery } from '../../../../hooks'
import {
  getImageUrl,
  exportExcel_addPercentage,
  getObjectAsArray,
  sortingDataForProgressionTabList,
} from '../../../../util'
import { LEGEND_COLOR_MAP_V2, ROLES_MM_PRIMARY, LEGEND_COLOR_MAP_NEW } from '../../../../constants'
import { useGlobalStore } from '../../../../store'
import D3AdaptiveChart from './D3LineGraph/D3LineGraph'
import Tab0Content from './Tab0Content/Tab0Content'
import Tab1Content from './Tab1Content/Tab1Content'
import {
  ReportHeading,
  LoaderWrapper,
  ReportBrandImageryEditHeaderLevel2,
  MuiButton,
  ReportOuterWrapper,
  CustomTabs,
  MuiImage
} from '../../../../components'

import {
  OuterWrapper
} from './style'
// import { Insights } from '@mui/icons-material'

const sortingDataEntityWise = (data) => {
  const arrBrand = data.filter((f) => f.entityType === 'Brand')
  const arrCompetitorBrand = data.filter((f) => f.entityType === 'CompetitorBrand')
  const arrRest = data.filter((f) => !['Brand', 'CompetitorBrand'].includes(f.entityType))
  return [...arrBrand, ...arrCompetitorBrand, ...arrRest]
}

const ReportBrandImageryGraphLevel2AndProgressionGraph = (props) => {
  const { showHeader = true, canMove = false, InsightsElementType } = props
  const [rows, setRows] = useState([])
  const [reportExcelData, setReportExcelData] = useState()
  const [editTitleData, setEditTitleData] = useState()
  const [expandedStatus, setExpandedStatus] = useState(false)
  const [showExpandAllCTA, setShowExpandAllCTA] = useState(false)
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const { user, projectIdValue, isPPTModalActive } = useGlobalStore()
  const editTitleFlag = ROLES_MM_PRIMARY.includes(user?.UserType) && !projectIdValue?.IsFreezed
  const [progressionDataL1Filtered, setProgressionDataL1Filtered] = useState({
    drivers: [],
    brands: [],
    periods: [],
  })
  const [progressionDataFiltered, setProgressionDataFiltered] = useState({
    drivers: [],
    brands: [],
    periods: [],
  })
  const [eventCount, setEventCount] = useState(1)
  const [brandImageryRowImg, setBrandImageryRowImg] = useState([])
  const [activeTab, setActiveTab] = useState(0)
  const [configTab, setConfigTab] = useState([])
  const [isExportToPptWithAppendices, setIsExportToPptWithAppendices] = useState(false)
  const [isExportToPptWithProgression, setIsExportToPptWithProgression] = useState(false)

  const hasTabs = InsightsElementType === 'BrandImageryMappingAndProgressionGraph'
  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc: hasTabs
        ? ReportsService.reportGetBrandImageryMappingAndProgressionGraphApi
        : ReportsService.reportGetBrandImageryGraphMappingApi,
      payload: { insightsElementId: props.InsightsElementId },
    },
  }
  const { data, isLoading, isSuccess, isError, error, refetch } = useReactQuery(useReactQueryObject)

  const excelSheetFunc = (rowArray) => {
    const reportExcelSheet1DataObject = {
      heading: [{ title: 'Driver', width: { wch: 30 } }, { title: 'Percent' }],
      values: [],
    }
    const reportExcelSheet2DataObject = {
      heading: [
        { title: 'Driver', width: { wch: 30 } },
        { title: 'Sub Driver', width: { wch: 30 } },
        { title: 'Percent' },
      ],
      values: [],
    }

    const logoDetails = []
    for (let i = 0; i < rowArray[0].data.length; i++) {
      reportExcelSheet1DataObject.heading.push({
        title: rowArray[0].data[i].logoName,
        titleId: rowArray[0].data[i].logoImg,
      })
      reportExcelSheet2DataObject.heading.push({
        title: rowArray[0].data[i].logoName,
        titleId: rowArray[0].data[i].logoImg,
      })
      logoDetails.push({
        logoName: rowArray[0].data[i].logoName,
        logoImg: rowArray[0].data[i].logoImg,
      })
    }

    for (let i = 0; i < rowArray.length; i++) {
      const rowValues1 = [{ value: rowArray[i].title }, { value: rowArray[i].per + '%' }]

      const arr1 = rowArray[i].data
      for (let j = 0; j < logoDetails.length; j++) {
        const obj = arr1.find((f) => f.logoImg === logoDetails[j].logoImg) || null
        if (obj) {
          rowValues1.push({ value: obj?.scale })
        } else {
          rowValues1.push({ value: '' })
        }
        // rowValues1.push({ value: rowArray[i]?.data[j]?.scale || 0 })
      }
      reportExcelSheet1DataObject.values.push(rowValues1)

      for (let j = 0; j < rowArray[i].nestedData.length; j++) {
        const rowValues2 = [{ value: rowArray[i].title }]
        rowValues2.push({ value: rowArray[i].nestedData[j].title })
        rowValues2.push({ value: rowArray[i].nestedData[j].per + '%' })

        const arr2 = rowArray[i]?.nestedData[j]?.data
        for (let k = 0; k < logoDetails.length; k++) {
          const obj = arr2.find((f) => f.logoImg === logoDetails[k].logoImg) || null
          if (obj) {
            rowValues2.push({ value: obj?.scale })
          } else {
            rowValues2.push({ value: '' })
          }
        }
        reportExcelSheet2DataObject.values.push(rowValues2)
      }
    }

    setReportExcelData({
      sheet1: reportExcelSheet1DataObject,
      sheet2: reportExcelSheet2DataObject,
    })
  }

  let scoreImageryTypeArray = {}
  let scoreImageryTypeArrayL2 = {}
  const filterDataObj = { drivers: [], brands: [], periods: [] }

  const generateProgressionGraphData = (resp, hasTabs) => {
    let isNestedData = false
    scoreImageryTypeArray = {}
    scoreImageryTypeArrayL2 = {}
    let brandsList = []

    const rowArrayDataFunc = (data, dataObj) => {
      filterDataObj.periods.push(dataObj?.title || '')
      const filterDataObjBrandsArr = []

      const finalArray1 = data.map((row, ind) => {
        const nestedData = getObjectAsArray(
          row?.BrandImageryMappingAttributes?.BrandImageryMappingAttribute
        )
        const nestedDataArray =
          nestedData?.map((b, index) => {
            return {
              driverId: b.DriverId,
              attributeId: b.AttributeId,
              title: b.AttributeName,
              show: index === 0,
              per: b.AttributePercent,
              data:
                getObjectAsArray(b.EntityIndexScoreImageryType.EntityIndexScoreImageryType).map(
                  (b) => {
                    return {
                      logoImg: b.Entity.EntityLogo,
                      logoName: b.Entity.EntityName,
                      entityType: b?.Entity?.EntityType,
                      scale: b.IndexScore,
                      type: b.ImageryType,
                    }
                  }
                ) || [],
            }
          }) || []

        if (!isNestedData && (!!nestedData.length || !!row?.Insights)) {
          isNestedData = true
        }

        filterDataObj.drivers.push(row.DriverName)
        // filterDataObj.drivers.push({[row.DriverName]:false})

        const finalData = {
          driverId: row?.DriverId,
          title: row?.DriverName,
          per: row?.DriverPercent,
          insights: row?.Insights,
          showLevel2: false,
          nestedData: nestedDataArray.map((m) => {
            m.data = sortingDataEntityWise(m.data).map((n) => {
              const id = `id_${row.DriverId}____${row.DriverName.replaceAll(' ', '')}____${m.attributeId}____${m.title.replaceAll(' ', '')}____${n.logoImg}____${n.logoName.replaceAll(' ', '')}`
              const obj = { val: n.scale, periodLabel: dataObj?.title || '' }
              if (scoreImageryTypeArrayL2[id] === undefined) {
                scoreImageryTypeArrayL2[id] = [obj]
              } else {
                scoreImageryTypeArrayL2[id].push(obj)
              }
              return n
            })
            return m
          }),
          data:
            sortingDataEntityWise(
              getObjectAsArray(row.EntityIndexScoreImageryType?.EntityIndexScoreImageryType)
            ).map((b) => {
              const id = `id_${row.DriverId}____${row.DriverName.replaceAll(' ', '')}____${b?.Entity?.EntityLogo}____${(b?.Entity?.EntityName).replaceAll(' ', '')}`
              const obj = { val: b?.IndexScore, periodLabel: dataObj?.title || '' }
              if (scoreImageryTypeArray[id] === undefined) {
                scoreImageryTypeArray[id] = [obj]
              } else {
                scoreImageryTypeArray[id].push(obj)
              }
              filterDataObj.brands.push(b?.Entity?.EntityName)
              brandsList.push(b?.Entity?.EntityName)

              // filterDataObjBrandsArr = [...filterDataObjBrandsArr, {entityName:b?.Entity?.EntityName, entityType:b?.Entity?.EntityType}]
              if (
                filterDataObjBrandsArr.filter((f) => f.entityName === b?.Entity?.EntityName)
                  .length === 0
              ) {
                filterDataObjBrandsArr.push({
                  entityName: b?.Entity?.EntityName,
                  entityType: b?.Entity?.EntityType,
                })
              }

              return {
                logoImg: b?.Entity?.EntityLogo,
                logoName: b?.Entity?.EntityName,
                entityType: b?.Entity?.EntityType,
                scale: b?.IndexScore,
                type: b?.ImageryType,
                scaleArray: [],
              }
            }) || [],
        }

        filterDataObj.brands = sortingDataEntityWise(filterDataObjBrandsArr).map( (m) => m.entityName )

        return finalData
      })

      return finalArray1
    }

    const scoreImageryTypeArrayRvisedDataFunc = (data) => {
      return data.map(d1 => {
        d1.periodArray = filterDataObj.periods        
        d1.scaleArray = filterDataObj.periods.map(d2 => {
          const val = d1.scaleArray.filter(f => f.periodLabel === d2)?.[0]?.val || null
          return {periodLabel: d2 ||'', val: val ? val : null}
        })
        return d1
      })
    }

    const configTabObject = hasTabs
      ? resp.map((d, i) => ({
          periodInsightsElementId: d.PeriodInsightsElementId,
          id: i,
          label: i === 0 ? d.PeriodName : 'Progression',
          tutorial: i === 0 ? 'CurrentPeriod' : 'Progression',
          title: d.PeriodName,
          periodOrder: d.PeriodOrder,
          data: getObjectAsArray(d.PeriodBrandImageryMappingElements.BrandImageryMappingElement),
        }))
      : []

    const rowArrayData = hasTabs
      ? configTabObject.map((d) => {
          d.data = rowArrayDataFunc(d.data, d)
          return d
        })
      : [rowArrayDataFunc(resp, null)]

    const rowArray = hasTabs ? rowArrayData[0].data : rowArrayData[0]
    const addScore = (d0) => {
      return d0.map((d1) => {
        d1.data.map((d2) => {
          d2.data.map((d3) => {
            const id = `id_${d2.driverId}____${d2.title.replaceAll(' ', '')}____${d3.logoImg}____${d3.logoName.replaceAll(' ', '')}`
            d3.periodArray = scoreImageryTypeArray[id].map((d) => d.periodLabel)
            d3.scaleArray = scoreImageryTypeArray[id]
            return d3
          })
          d2.data = scoreImageryTypeArrayRvisedDataFunc(d2.data)

          d2.nestedData.map((d3) => {
            d3.data.map((d4) => {
              const id = `id_${d2.driverId}____${d2.title.replaceAll(' ', '')}____${d3.attributeId}____${d3.title.replaceAll(' ', '')}____${d4.logoImg}____${d4.logoName.replaceAll(' ', '')}`
              d4.scaleArray = scoreImageryTypeArrayL2[id]
              return d4
            })
            d3.data = scoreImageryTypeArrayRvisedDataFunc(d3.data)
            return d3
          })
          return d2
        })
        return d1
      })
    }

    if (hasTabs) {
      setConfigTab(addScore(configTabObject))
    }

    const removeUsingSet = (arr) => {
      let outputArray = Array.from(new Set(arr))
      return sortingDataForProgressionTabList(outputArray)
    }

    setProgressionDataL1Filtered({
      drivers: removeUsingSet(filterDataObj.drivers),
      brands: removeUsingSet(brandsList),
      periods: removeUsingSet(filterDataObj.periods),
    })
    setShowExpandAllCTA(isNestedData)
    setRows(rowArray)
    excelSheetFunc(rowArray)
    updateSubLhsApiLoaded(props)
    setEventCount((p) => p + 1)

    if(isPPTModalActive){
      const logoDetails = rowArray[0].data.map(d => ({logoImg: d.logoImg, logoName: d.logoName}))
      setBrandImageryRowImg(logoDetails)
    }

  }

  const patchForData = (data) => {
    const data1 = data[0]
    const getEntityIndexScoreImageryType = getObjectAsArray(
      data1.PeriodBrandImageryMappingElements.BrandImageryMappingElement
    )
    let getEntityIndexScoreImageryTypeArray = []
    for (let i = 0; i < getEntityIndexScoreImageryType.length; i++) {
      const arr = getObjectAsArray(
        getEntityIndexScoreImageryType[i].EntityIndexScoreImageryType.EntityIndexScoreImageryType
      )
      if (arr.length > getEntityIndexScoreImageryTypeArray.length) {
        getEntityIndexScoreImageryTypeArray = arr.map((d) => ({
          ...d,
          IndexScore: 10,
          ImageryType: 'PatchObject',
        }))
      }
    }

    for (let i = 0; i < getEntityIndexScoreImageryType.length; i++) {
      const arr = getObjectAsArray(
        getEntityIndexScoreImageryType[i].EntityIndexScoreImageryType.EntityIndexScoreImageryType
      )
      if (arr.length !== getEntityIndexScoreImageryTypeArray.length) {
        getEntityIndexScoreImageryType[i].EntityIndexScoreImageryType.EntityIndexScoreImageryType =
          getEntityIndexScoreImageryTypeArray.map((d) => {
            const onlyKeys = arr.map((name) => name.Entity.EntityName)
            if (onlyKeys.includes(d.Entity.EntityName)) {
              d = arr.find((f) => f.Entity.EntityName === d.Entity.EntityName)
            }
            return d
          })
      }
    }

    const finalData = data
    finalData[0] = data1
    return finalData
  }

  const changeHandler = (row) => {
    const newRows = rows.map((item) => {
      if (item.title === row.title) {
        return {
          ...item,
          data: row.data,
        }
      }
      return item
    })
    setRows(newRows)
  }

  const editTitleClicked = (row) => {
    setEditTitleData(row)
  }

  const updateDriversHeading = () => {
    setEditTitleData(null)
    refetch()
  }

  const showLevel2Func = (row, i) => {
    const updateRow = [...rows]
    updateRow[i].showLevel2 = !updateRow[i].showLevel2
    setRows(updateRow)
  }

  const showTabContent = (row, index) => {
    const r = [...rows]
    r[index].nestedData = r[index].nestedData.map((s) => {
      s.show = s.attributeId === row.attributeId
      return s
    })

    setRows(r)
  }

  const expandCollapseFunc = (flag, rows) => {
    setExpandedStatus(flag)
    const data = rows.map((d) => {
      d.showLevel2 = flag
      return d
    })
    setRows(data)
    setEventCount((p) => p + 1)
  }

  const AdditionalButtons = ({ expandedStatus, expandCollapseFunc, rows, expanded }) => {    
    return (
      <MuiButton
        variant='outlined'
        color='light'
        startIcon={expandedStatus ? <IconArrowUpBig /> : <IconArrowDown />}
        onClick={() => expandCollapseFunc(!expandedStatus , rows)}
      >
        {expandedStatus ? 'Collapse All' : 'Expand All'}
      </MuiButton>
    )
  }

  const filterChangeFunc = (data) => {
    setProgressionDataFiltered(data)
  }

  useEffect(() => {
    setIsExportToPptWithProgression(
      props?.isProgressionActive === 'Progression__' &&
        props.InsightsElementType === 'BrandImageryMappingAndProgressionGraph'
    )
  }, [props])

  useEffect(() => {
    setEventCount((p) => p + 1)
  }, [rows])

  const onSuccessFunc = (resp) => {
    const finalResp = hasTabs ? patchForData(resp) : resp
    generateProgressionGraphData(finalResp, hasTabs)
  }

  useEffect(() => {
    if (isSuccess && data?.length) onSuccessFunc(data)
  }, [isSuccess, data])

  return (
    <>
      {showHeader && (
        <ReportHeading
          resetInsightHeight={eventCount}
          downloadId={props.type}
          subHeading=''
          {...props}
          downloadIdData={reportExcelData}
          addTable={true}
          additionalButton={
            showExpandAllCTA && (
              <AdditionalButtons
                expandedStatus={expandedStatus}
                expandCollapseFunc={expandCollapseFunc}
                rows={rows}
                expanded={expandedStatus}
              />
            )
          }
        />
      )}

      {editTitleFlag && editTitleData && (
        <ReportBrandImageryEditHeaderLevel2
          pageInsights={editTitleData?.insights}
          insightsElementId={
            configTab?.filter((f) => f?.periodOrder === 1)?.[0]?.periodInsightsElementId ||
            props.InsightsElementId
          }
          driverId={editTitleData.driverId}
          driverName={editTitleData.title}
          onSuccess={updateDriversHeading}
          onClose={() => setEditTitleData(null)}
        />
      )}

      <ReportOuterWrapper>
        <OuterWrapper
          id={props.type}
          className={`brandImageryOuterWrapper showExpandAllCTA_${showExpandAllCTA} ${(props?.isPPTModalActive || props?.isProgressionActive) ? 'exportToPPT' : ''}`}
        >
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
          >
            {isPPTModalActive && brandImageryRowImg?.length>0 && brandImageryRowImg.map(d => {
              return (
                <div className={`brandImageryRowImg ${d.logoName.replaceAll(' ', '')}`} style={{height: '15px', width: 'fit-content', display: 'flex'}} title={d.logoName}>
                  <MuiImage
                    src={getImageUrl('logos', d?.logoImg, 'png')}
                    alt={d.logoName}
                    style={{height: '15px', width: 'fit-content'}}
                  />
                </div>
              )
            })}

            {!isPPTModalActive && <>
              {configTab && props.InsightsElementType === 'BrandImageryMappingAndProgressionGraph' && <CustomTabs
                options={[
                  { id: 0, label: configTab?.[0]?.label || '0' },
                  { id: 1, label: configTab?.[1]?.label || '1' },
                ]}
                onChange={d => {setActiveTab(d); setEventCount((p) => p + 1)}}
                value={activeTab}
                styletype='themeV2'
              />}

              {activeTab===0 && (
                <Tab0Content
                  rows={rows}
                  canMove={canMove}
                  showExpandAllCTA={showExpandAllCTA}
                  editTitleFlag={editTitleFlag}
                  editTitleClicked={editTitleClicked}
                  showLevel2Func={showLevel2Func}
                  onChange={changeHandler}
                />
              )}
              {activeTab===1 && (
                <Tab1Content
                  rows={rows}
                  canMove={canMove}
                  showExpandAllCTA={showExpandAllCTA}
                  editTitleFlag={editTitleFlag}
                  editTitleClicked={editTitleClicked}
                  showLevel2Func={showLevel2Func}
                  showTabContent={showTabContent}
                  progressionDataL1Filtered={progressionDataL1Filtered}
                  progressionDataFiltered={progressionDataFiltered}
                  filterChangeFunc={filterChangeFunc}
                  isExportToPptWithProgression={isExportToPptWithProgression}
                  onChange={changeHandler}
                />
              )}
            </>}

          </LoaderWrapper>
        </OuterWrapper>
      </ReportOuterWrapper>
    </>
  )
}

export default ReportBrandImageryGraphLevel2AndProgressionGraph